import BaseApi from "./_base-api";

/**
 * Report API
 *
 * @class Api
 * @extends {BaseApi}
 */
class Api extends BaseApi {
	deliverable(params) {
		this.log().info("[Services: Report]: Get Deliverable Report", params);
		return this.api()
			.get(this.getUrl("report", `deliverables/${params.id}`), { params })
			.catch((error) => {
				this.log().error(
					"[Services: Report: Deliverable Report]: Error",
					error
				);
				throw this.utils.resolveError(error);
			});
	}}

const api = new Api({
	type: "Report",
	path: "reports",
});

export default api;
